export default __webpack_public_path__ + "static/titilliumweb-regular-webfont-0f2948de43661498e3a2f2fb62f539b3.woff";